<div class="bg-white rounded-lg shadow-sm p-4 hover:bg-gray-50 transition-colors h-18 flex items-center">
  @if (isEditing()) {
    <div class="flex items-center justify-between gap-4 w-full">
      <div class="flex flex-col gap-2 flex-1">
        <div class="flex items-center gap-2">
          <input 
            type="number" 
            [value]="size().width" 
            (input)="onWidthChange($event)"
            class="w-16 px-2 py-1 border border-gray-300 rounded text-center"
            min="1"
          >
          <span class="text-gray-600">×</span>
          <input 
            type="number" 
            [value]="size().height" 
            (input)="onHeightChange($event)"
            class="w-16 px-2 py-1 border border-gray-300 rounded text-center"
            min="1"
          >
          <span class="text-gray-600">cm</span>
        </div>
        <label class="flex items-center justify-center gap-2">
          <input 
            type="checkbox" 
            [checked]="size().mostPopular || false"
            (change)="onMostPopularChange($event)"
            class="rounded"
          >
          <span class="text-sm text-gray-600">Most Popular</span>
        </label>
      </div>
      <div class="text-right flex items-center gap-2">
        <div class="flex items-center gap-1">
          <span class="text-gray-600">€</span>
          <input 
            type="number" 
            [value]="size().price" 
            (input)="onPriceChange($event)"
            class="w-20 px-2 py-1 border border-gray-300 rounded text-right"
            step="0.01"
            min="0"
          >
        </div>

        <!-- delete button visible only in edit mode -->
        <button
          type="button"
          (click)="onRemove()"
          class="ml-3 inline-flex items-center justify-center h-8 w-8 rounded-md bg-red-50 text-red-600 hover:bg-red-100"
          aria-label="Remove size"
          title="Remove size"
        >
          &times;
        </button>
      </div>
    </div>
  } @else {
    <div class="flex items-center justify-between w-full">
      <div class="flex flex-col gap-1 items-center">
        <span class="font-semibold text-lg text-gray-900">
          {{ size().width }} × {{ size().height }} cm
        </span>
        @if (size().mostPopular) {
          <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
            Most Popular
          </span>
        }
      </div>
      <div class="text-right flex items-center gap-2">
        <!-- Promotion button with date range -->
        @if (promotion()) {
          <button
            type="button"
            (click)="onPromotionClick()"
            class="inline-flex flex-col items-center justify-center px-2 py-1 rounded-full bg-yellow-100 text-yellow-800 hover:bg-yellow-200 text-xs font-medium"
            title="Promotion: {{ promotion()!.startDate }} - {{ promotion()!.endDate }}"
          >
            <span>From: <span class="font-black">{{ formatDateDisplay(promotion()!.startDate) }}</span></span>
            <span>To: <span class="font-black">{{ formatDateDisplay(promotion()!.endDate) }}</span></span>
          </button>
        } @else {
          <button
            type="button"
            (click)="onPromotionClick()"
            class="inline-flex items-center justify-center px-3 py-1.5 rounded-full bg-yellow-100 text-yellow-800 hover:bg-yellow-200 text-xs font-medium"
            aria-label="Create promotion"
            title="Create promotion"
          >
            Add Promotion
          </button>
        }
        
        <!-- Price display with promotion logic -->
        <div class="text-right">
          @if (promotion()) {
            <!-- Show promotion price and original price below -->
            <div class="text-xl font-bold text-green-600">
              {{ promotion()!.discountPrice | currency:'EUR':'symbol':'1.2-2' }}
            </div>
            <div class="text-sm text-gray-400 line-through">
              {{ size().price | currency:'EUR':'symbol':'1.2-2' }}
            </div>
          } @else {
            <!-- Show regular price -->
            <span class="text-xl font-bold text-green-600">
              {{ size().price | currency:'EUR':'symbol':'1.2-2' }}
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>